import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from '@aytm/lib/rfd-ui/styles/SuggestionsComponent.module.scss'

const SuggestionItem = ({ suggestion, index, selectedIndex, selectSuggestion }) => (
  <div
    onMouseDown={event => {
      event.preventDefault()
      selectSuggestion(suggestion)
    }}
    id={'suggestion-item-' + index}
    className={classNames(styles.item, {
      [styles['item--active']]: index === selectedIndex
    })}
  >
    <div className={styles['content']}>
      <div className={styles['content-text']}>
        <strong>{suggestion.label}</strong>
      </div>
    </div>
  </div>
)

SuggestionItem.propTypes = {
  index: PropTypes.number,
  suggestion: PropTypes.object,
  selectSuggestion: PropTypes.func,
  selectedIndex: PropTypes.number
}

export default SuggestionItem
